import { Button } from '@medely/ui-kit';
import React from 'react';
import { useShiftSwapMutations } from './mutations';

type CancelReleaseButtonProps = {
  jobId?: number | null;
  shiftRequestId?: number | null;
};

export const CancelReleaseButton = ({ jobId, shiftRequestId }: CancelReleaseButtonProps) => {
  const { cancelShiftRequest, isLoading } = useShiftSwapMutations();

  if (!shiftRequestId && !jobId) {
    return null;
  }

  return (
    <Button
      variant="outlined"
      onClick={() => cancelShiftRequest({ jobId: jobId as number, id: shiftRequestId as number })}
      disabled={isLoading}
      fullWidth
    >
      Cancel release
    </Button>
  );
};
